import React from "react";
import { Link } from "react-scroll";
import { Button } from "react-bootstrap";
import "./callToAction.css";

const CallToAction = ({ phoneNumber, imageBackground }) => {
  return (
    <div className="call-to-action-container">
      <div
        className="call-to-action-image"
        style={{ backgroundImage: `url(${imageBackground})` }}
      >
        <div className="background-image-overlay"></div>
        <div className="call-to-action-text">
          <h2 className="fw-bold">Get the garden you've always wanted!</h2>
          <h2>Call us at {phoneNumber}</h2>
          <Link to="contact" spy={true}>
            <Button
              className="mt-3"
              size="lg"
              style={{
                backgroundColor: "var(--primary)",
                borderColor: "var(--primary)",
              }}
            >
              Get in touch
            </Button>
          </Link>
        </div>
      </div>
      <div className="call-to-action-overlay">
        <div className="call-to-action-box">
          <div className="call-to-action-box-item">
            <span>10+</span>
            <p>Years of Experience</p>
          </div>
          <div className="call-to-action-box-item">
            <span>1000+</span>
            <p>Happy Customers</p>
          </div>
          <div className="call-to-action-box-item">
            <span>500+</span>
            <p>Gardens Created</p>
          </div>
          <div className="call-to-action-box-item">
            <span>25+</span>
            <p>Team Members</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
